import useSWR from 'swr'
import fetchJson from '@/utils/fetchJson'
import { useRouter } from 'next/router'

export default function useUser() {
  const router = useRouter()
  const { data, mutate, error } = useSWR<{
    message: string
    color: string
    logo: string
    reportOptions?: {
      hideSaasAlertsCoBranding?: boolean
    }
  }>('/api/session', {
    revalidateOnFocus: true,
  })

  const isLoading = !data && !error
  const isLoggedOut = error !== undefined

  const logout = async () => {
    try {
      await fetchJson('/api/logout')
      sessionStorage.removeItem('reportFilter')
    } catch (error: any) {
      /* If logout is called after the session expires, this will return Unauthorized error.
       * This usually happens if the user has multiple tabs open and the session expires.
       */
      if (error.response?.error === 'Unauthorized') {
        const currentUrl = router.asPath
        router.push(`/auth?redirect=${encodeURIComponent(currentUrl)}`)
        return null
      }
    }
  }

  const login = async (token: string) => {
    await fetchJson('/api/login', {
      method: 'POST',
      headers: { 'X-SaaSAlerts-Token': token },
    })
  }

  return {
    isLoading,
    isLoggedOut,
    mutate,
    logout,
    login,
    data,
  }
}
